export const SHOP_PAYMENT_TRANSACTION_REQUEST = 'SHOP_PAYMENT_TRANSACTION_REQUEST';
export const SHOP_PAYMENT_TRANSACTION_SUCCESS = 'SHOP_PAYMENT_TRANSACTION_SUCCESS';